import { supabase } from "../supabase/supabase";
import { GetTodaysDateString } from "../utils/GetDate";

export class PageView {
    email: string;
    date: string;

    constructor(email: string, date: string) {
        this.email = email;
        this.date = date;
    }

    static async addNewPageView(page: string) {
        const todaysDateString = GetTodaysDateString();
        const { data, error } = await supabase
            .from("PageViews")
            .insert({
                page: page,
                date: todaysDateString,
            });
    }
}